import React from 'react';

export interface SectionProps {
    children?: React.ReactNode;
    className?: string;
}

export const Section: React.FC<SectionProps> = props => (
    <section className={'flex flex-col gap-4 px-10 py-5 ' + (props.className ?? '')}>
        {props.children}
    </section>
);
